import { type QueryLazyOptions } from '@apollo/react-hooks'
import { useCallback } from 'react'
import {
  type Exact,
  useGetRetailerCollectionsBannerDestinationLazyQuery,
  useGetRetailerCollectionsMeshLazyQuery,
} from 'domains/merchandising/api'
import { retailerCollectionsAccessControl } from 'domains/retailer-collections/access-control/retailerCollectionsAccess.configuration'
import { useDomainAccessControl } from 'domains/retailer-collections/utils/domain/accessControl'

export const useGetCollectionsLazy = () => {
  const [getRetailerCollections, retailerCollectionsResponse] =
    useGetRetailerCollectionsBannerDestinationLazyQuery()
  const [getICCollections, ICCollectionsResponse] = useGetRetailerCollectionsMeshLazyQuery()

  const hasAccess = useDomainAccessControl()
  const retailerCollectionsEnabled = hasAccess(retailerCollectionsAccessControl)

  const retailerCollections =
    retailerCollectionsResponse?.data?.collectionsServiceGetCollections?.collections?.filter(
      collection => !collection.parentId
    ) ?? []
  const icCollections = ICCollectionsResponse?.data?.collectionSearch?.nodes ?? []

  const getCollections = useCallback(
    (options: QueryLazyOptions<Exact<{ retailerId: string }>>) => {
      getICCollections(options)

      if (retailerCollectionsEnabled) {
        getRetailerCollections(options)
      }
    },
    [getICCollections, getRetailerCollections, retailerCollectionsEnabled]
  )

  return {
    getCollections,
    loading: retailerCollectionsResponse.loading || ICCollectionsResponse.loading,
    error: retailerCollectionsResponse.error || ICCollectionsResponse.error,
    collections: [...retailerCollections, ...icCollections],
  }
}
